<template>
  <span :class="`report-status-inline report-status-inline--${color}`">
    {{ statusText }}
  </span>
</template>

<script>
import { REPORT_STATUSES } from '@/store/report/report-settings'
import { renderValue } from '@/helpers/render'

const COLORS = {
  default: 'default',
  coral: 'coral',
}

const REPORT_STATUS_COLORS = {
  [REPORT_STATUSES.inProgress]: COLORS.default,
  [REPORT_STATUSES.paymentReceived]: COLORS.default,
  [REPORT_STATUSES.waitingForDocument]: COLORS.coral,
  [REPORT_STATUSES.waitingForApproval]: COLORS.coral,
  [REPORT_STATUSES.waitingForSignatures]: COLORS.coral,
}

export default {
  name: 'ReportStatusInline',

  props: {
    status: {
      type: String,
      validator(value) {
        return typeof value === 'undefined' || Object.values(REPORT_STATUSES).includes(value)
      },
    },

    hasColor: {
      type: Boolean,
      default: true,
    },

    isUsingFallbackCharacter: {
      type: Boolean,
      default: true,
    },

    translationObject: {
      type: Object,
    },
  },

  computed: {
    color() {
      return (this.hasColor && REPORT_STATUS_COLORS[this.status]) || COLORS.default
    },

    statusText() {
      if (!this.status) return this.renderValue('')

      const text =
        this.translationObject && this.status in this.translationObject
          ? this.translationObject[this.status]
          : this.$t(`account.reports.status.${this.status}`)

      return this.renderValue(text)
    },
  },

  methods: {
    renderValue(value) {
      return this.isUsingFallbackCharacter ? renderValue(value) : value || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.report-status-inline {
  &--coral {
    color: darken($color-brand-coral-light, 10);
  }
}
</style>
